import React from "react";
import styled from "styled-components";
import Text from "../../parts/Text";
import { GetAdministratorsOwners200ResponseInner } from "../../../../api/v1";

type OwnerListComponentProps = {
  owners: Array<GetAdministratorsOwners200ResponseInner>;
};

const OwnerCardsStyle = styled.div`
  display: flex;
  border-top: 1px solid #dbdbdb;
  text-decoration: none;
  padding: 30px;

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 12px;
  }

  &:hover {
    background-color: #eeeeee;
    transition: background-color 0.3s ease-in-out;
  }
`;

const OwnerCardColumnLeft = styled.div`
  margin-right: 20px;
`;

const AdministratorOwnerList: React.FC<OwnerListComponentProps> = ({
  owners,
}) => {
  return (
    <>
      {owners.map((owner, index) => {
        return (
          <OwnerCardsStyle key={index}>
            <OwnerCardColumnLeft>
              <Text size="14px" weight="bold" mb="5px">
                メールアドレス : {owner.email}
              </Text>
              <Text size="14px" mb="5px">
                ID : {owner.id}
              </Text>
              <Text size="14px" mb="5px">
                名前 : {owner.name}
              </Text>
              <Text size="14px" mb="5px">
                登録日 : {owner.createdAt}
              </Text>
            </OwnerCardColumnLeft>
          </OwnerCardsStyle>
        );
      })}
    </>
  );
};

export default AdministratorOwnerList;
